import {
    SSONewUserCookieType,
    SSONewUserDetails,
} from '@99designs/apps/spa/pages/auth/SSO/common/types';
import { getCookieByName } from '@99designs/browser';

export default function getSSONewUserDetails(): SSONewUserDetails | null {
    try {
        const cookieVal = getCookieByName('_99ssonewuser', document.cookie);
        const cookie: SSONewUserCookieType = JSON.parse(atob(cookieVal));
        return {
            source: cookie.source,
            target: cookie.target,
            cancelTarget: cookie.cancel_target,
            expiresAt: new Date(cookie.expires_at),
            requires_marketing_opt_in: cookie.requires_marketing_opt_in,
            role: cookie.role,
            isExpired(): boolean {
                return this.expiresAt.getTime() < new Date().getTime();
            },
        };
    } catch (e) {
        return null;
    }
}
